import React, { useState, useEffect } from "react";
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import {
  InteractionType,
} from "@azure/msal-browser";
import { loginRequest } from "../authConfig";
// Sample app imports
import { SendInquiryForm } from "../components/SaleInquiry/SendInquiryForm";
import { Loading } from "../components/Loading";
import { ErrorComponent } from "../components/ErrorComponent";
import { api_path } from "../shared";
export function SendInquiry() {
  const authRequest = {
    ...loginRequest,
  };

  const getUserID = JSON.parse(localStorage.getItem('USER_ID'));
 const getUserRole = JSON.parse(localStorage.getItem('USER_ROLE_ID'));
  const getUserEMail = JSON.parse(localStorage.getItem('USER_EMAIL'));
  const getEmpCode = JSON.parse(localStorage.getItem('USER_EMPCODE'));
  // const [getUserRole, setUserRole] = useState();
  // const [getUserID, setUserID] = useState();
  // const [getUserEMail, setUserEmail] = useState("");
  // const { accounts } = useMsal();
  const SendInquiryContent = () => {
    return <SendInquiryForm
    USER_ID={getUserID}
    USER_EMAIL={getUserEMail}
    USER_ROLE={getUserRole}
    />;
  };
  // useEffect(() => {
  //   setUserEmail(accounts[0]?.username);
  //   fetchUserRole(accounts[0]?.username);
  // });
  // function fetchUserRole(userEmail) {
  //   fetch(api_path + "/USER_ROLE.php?USER_EMAIL=" + userEmail)
  //     .then((res) => res.json())
  //     .then((res) => {
  //       const array = res;
  //       for (const i of array) {
  //         if(i.USER_ROLE_ID==0){
  //           window.location = "/s-crm/Home?status=denined";
  //         }else{
  //           setUserRole(i.USER_ROLE_ID);
  //           setUserID(i.CRM_UID);
  //         }
  //       }
  //     });
  // }
  // useEffect(() => {
  //   var data = {
  //     ROLE_ID: getUserRole,
  //     USER_EMAIL: getUserEMail,
  //     MENU_URL:window.location.pathname,
  //   };
  //   fetch(api_path + "/GET_AUTHEN_URL.php", {
  //     method: "POST",
  //     headers: {
  //       Accept: "application/form-data",
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((result) => {
  //         if (result["status"] == "200") {
  //           if (result["success"] == "0") {
  //             window.location = "/s-crm/Home?status=denined";
  //           }
  //         }
  //     });
  // }, []);
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <SendInquiryContent />
    </MsalAuthenticationTemplate>
  );
}
